import { Typography } from '@mui/material';
import { styled } from '@mui/system';
import PropTypes from 'prop-types';

export function Branding({ placement }) {
  let BrandContainer = CenteredBrandContainer;
  let brandTextVariant = 'brandText';
  if (placement === 'top') {
    BrandContainer = TopBrandContainer;
    brandTextVariant = 'brandText2';
  }
  return (
    <BrandContainer>
      <MsuiitLogo275x2801 src="msuiit-logo-275x280.png" alt="msuiit-logo" />
      <Typography variant={brandTextVariant} component="h1" color="error">
        Alumni Tracer
      </Typography>
    </BrandContainer>
  );
}

Branding.propTypes = {
  placement: PropTypes.string,
};

const CenteredBrandContainer = styled('div')({
  display: 'flex',
  width: 'fit-content',
  alignItems: 'center',
  gap: '20px',
  border: '1px none',
  height: '10vh',
});

const TopBrandContainer = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  padding: '20px 40px',
  width: 'fit-content',
  alignItems: 'center',
  gap: '1vh',
  height: '7vh',
  position: 'absolute',
  top: '0px',
  left: '0px',
});

const MsuiitLogo275x2801 = styled('img')({
  height: '100%',
  objectFit: 'cover',
});
